import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/phyohandmade/footer';
import Header from '../components/phyohandmade/header';
import HomePage from '../pages/phyohandmade/home_page';
import AboutPage from '../pages/phyohandmade/about_page';
import ContactPage from '../pages/phyohandmade/contact_page';
import OurArtPage from '../pages/phyohandmade/our_artisan';


export default function PhyohandmadeTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
                ourartPage={OurArtPage}
            />
            <Footer />
        </React.Fragment>
    )
}
